<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      agents: [],

      // end asets expensis

      purchases: [],
      showedEditedPurchase: {},
      agent: {},
      editedAgent: {},

      currentExpensis: [],
      addAsset: [{}],
      addExpense: [{}],
      addAccounts: [{}],
      seletedPurchase: {},
      seletedEditedPurchase: {},
      addPurchase: [
        {
          addAsset: [{}],
          addExpense: [{}],
          purchaseType: "",
        },
      ],

      editAgent: {},
      isOnCredit: true,
      page: 1,
      limit: 20,
      tot_pages: 0,
      branch_id: null,
      searchModel: "",
      reference_no: null,
    };
  },
  methods: {
    // assets expensis

    showPurchase(purchase) {
      console.log("step 162 :", purchase);

      this.showedEditedPurchase = purchase;
    },

    get(page) {
      console.log(page);
      this.http
        .post("purchases/incoming-fixed-assets/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.purchases = res.data;
          this.purchases.forEach((purchase) => {
            purchase.total = 0;
            purchase?.purchase_order_details.forEach((detail) => {
              purchase.total +=
                parseFloat(detail.unit_price) * parseFloat(detail.qty);
            });
          });
        });
    },
    search(page) {
      if (!this.searchModel.length) return this.cancelSearchMode();
      this.http
        .post("purchases/incoming-fixed-assets/search", {
          limit: this.limit,
          page: page,
          search: this.searchModel,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.purchases = res.data;
          this.purchases.forEach((purchase) => {
            purchase.total = 0;
            purchase?.purchase_order_details.forEach((detail) => {
              purchase.total +=
                parseFloat(detail.unit_price) * parseFloat(detail.qty);
            });
          });
        });
    },
    cancelSearchMode() {
      this.get(this.page);
    },
    receiveAssets(record) {
      console.log("Hi");

      // var data = {
      //   title: "popups.confirm",
      //   msg: "purchases.receive",
      // };
      // this.popup.confirm(data).then((resp) => {
      //   if (resp) {
      //     this.http.post("purchases/receive", { order: record }).then((res) => {
      //       if (res.status) {
      //         this.get(this.page);
      //       }
      //     });
      //   }
      // });
      var data = {
        title: "purchases.receive_assets",
        inputs: [
          {
            model: "goods_received_reference_no",
            type: "text",
            label: "popups.gr_ref_no",
          },
        ],
        buttons: [
          {
            text: "customers.recive",
            closer: true,
            color: "primary",
            handler: (obj) => {
              record.goods_received_reference_no =
                obj.goods_received_reference_no;
              this.http
                .post("purchases/receive", { order: record })
                .then((res) => {
                  if (res.status) {
                    this.get(this.page);
                  }
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
  },
  created() {
    this.get(1);
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.accounting.subItems.incoming-fixed-assets')"
    />
    <div class="row">
      <div class="card">
        <div class="card-body">
          <div class="row mb-4">
            <div class="col-6">
              <div class="search-box chat-search-box w-50">
                <div class="position-relative">
                  <input
                    @input="search(page)"
                    type="search"
                    class="form-control fa-lg text-light"
                    :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                    :placeholder="$t('popups.search')"
                    v-model="searchModel"
                    style="background-color: #2a3042 !important"
                  />
                  <i class="bx bx-search-alt search-icon text-light"></i>
                </div>
              </div>
            </div>
            <div class="col-6"></div>
          </div>
          <div class="table-responsive">
            <table
              class="table table-centered table-nowrap table-striped table-hover align-middle"
            >
              <thead>
                <tr
                  class="text-light"
                  style="background-color: #2a3042 !important"
                >
                  <th scope="col">#</th>
                  <th scope="col">{{ $t("purchases.code") }}</th>
                  <th scope="col">{{ $t("purchases.created") }}</th>
                  <th scope="col">{{ $t("purchases.gr_time") }}</th>

                  <th scope="col">{{ $t("popups.po_ref_no") }}</th>
                  <th scope="col">{{ $t("popups.gr_ref_no") }}</th>
                  <th scope="col">{{ $t("purchases.supplier") }}</th>
                  <th scope="col">{{ $t("purchases.total") }}</th>

                  <th scope="col">{{ $t("purchases.operations") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(app, index) in purchases" :key="app" class="">
                  <td>{{ (page - 1) * limit + index + 1 }}</td>
                  <td>{{ "#" + app?.id }}</td>
                  <td class="text-center">
                    {{
                      app.excution_time
                        ? new Date(app.excution_time).toLocaleString()
                        : " - "
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      app.gr_time
                        ? new Date(app.gr_time).toLocaleString()
                        : " - "
                    }}
                  </td>

                  <td class="text-center">
                    {{ app?.reference_no ? app?.reference_no : "-" }}
                  </td>
                  <td class="text-center">
                    {{
                      app?.goods_received_reference_no
                        ? app?.goods_received_reference_no
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? app?.agent?.name
                        : app?.agent?.name_en
                    }}
                  </td>

                  <td>{{ app?.total.toLocaleString() }}</td>

                  <td>
                    <button v-if="app.excution_time && app.gr_time" class="btn">
                      <i
                        v-if="app.excution_time"
                        style="color: green"
                        class="bx bx-check fa-2x"
                      ></i>
                    </button>
                    <button
                      v-if="app.excution_time && !app.gr_time"
                      type="button"
                      style="margin-inline-end: 4px"
                      class="btn btn-success btn-sm"
                      @click="receiveAssets(app)"
                    >
                      {{ $t("purchases.receive_assets") }}
                    </button>
                    <button
                      data-bs-target="#seeModal"
                      data-bs-toggle="modal"
                      @click="showPurchase(app)"
                      v-if="app.excution_time"
                      class="btn"
                    >
                      <i
                        v-if="app.excution_time"
                        class="text-primary bx bx-show fa-2x"
                      ></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end  table -->

    <!--Start Add Modal-->

    <!--End Add Modal-->

    <!--Start Edit Modal-->

    <!--End Edit Modal-->

    <!--Start Complete Modal-->

    <!--End Complete Modal-->

    <!--Start See Modal-->
    <div
      class="modal fade"
      id="seeModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <form>
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                {{ $t("purchases.order_details") }}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style="margin: 0"
              ></button>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="col-6"></div>
                <div
                  class="col-6"
                  style="display: flex; justify-content: flex-end"
                >
                  <!-- <button
                    type="button"
                    @click="
                      addPurchase.push({
                        addAsset: [{}],
                        addExpense: [{}],
                        addAccounts: [{}],
                        purchaseType: '',
                      })
                    "
                    class="btn float-end"
                  >
                    <span
                      class="bx bxs-plus-circle float-end fa-2x"
                      style="color: #2a3042 !important"
                    ></span>
                  </button> -->
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <h6 for="asset_id">{{ $t("purchases.supplier") }}</h6>
                  <h5>
                    {{
                      $i18n.locale == "ar"
                        ? showedEditedPurchase?.agent?.name
                        : showedEditedPurchase?.agent?.name_en
                    }}
                  </h5>
                </div>
                <div class="col"></div>
              </div>
              <div class="purchase-container">
                <div class="row">
                  <div class="row d-flex align-items-center">
                    <div class="col">
                      <h6 for="asset_id">{{ $t("purchases.items.text") }}</h6>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>{{ $t("purchases.items.name") }}</th>
                          <th>{{ $t("purchases.items.unit_price") }}</th>
                          <th>{{ $t("purchases.items.qty") }}</th>
                          <th>{{ $t("purchases.items.sub_total") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in showedEditedPurchase.purchase_order_details"
                          :key="item"
                        >
                          <td
                            v-if="
                              showedEditedPurchase.purchase_order_type.code ==
                              'expenses'
                            "
                          >
                            {{
                              $i18n.locale == "ar"
                                ? item?.level_three_chart_of_account?.name
                                : item?.level_three_chart_of_account?.name_en
                            }}
                          </td>
                          <td v-else>
                            {{
                              $i18n.locale == "ar"
                                ? item?.fixed_asset?.name +
                                  " - " +
                                  item?.serial_no
                                : item?.fixed_asset?.name_en +
                                  " - " +
                                  item?.serial_no
                            }}
                          </td>
                          <td>
                            {{ parseFloat(item.unit_price)?.toLocaleString() }}
                          </td>
                          <td>{{ parseInt(item.qty)?.toLocaleString() }}</td>
                          <td>
                            {{
                              (
                                parseInt(item.qty) * parseFloat(item.unit_price)
                              ).toLocaleString()
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <th>{{ $t("payments.items.total") }}</th>
                          <th class="total-style">
                            {{
                              parseFloat(
                                showedEditedPurchase?.total
                              ).toLocaleString()
                            }}
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="modal-footer"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            >
              <button class="btn btn-primary" disabled>
                {{ $t("payments.completed") }}
              </button>
              <button
                data-bs-dismiss="modal"
                type="button"
                class="btn btn-danger"
              >
                {{ $t("popups.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--End See Modal-->

    <!--   Purchases  Pagination     -->
    <ul class="pagination pagination-rounded justify-content-center mb-2">
      <li class="page-item" :class="{ disabled: page == 1 }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="get(page - 1)"
          aria-label="Previous"
        >
          <i class="mdi mdi-chevron-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        :class="{ active: p == page }"
        v-for="p in tot_pages"
        :key="p"
      >
        <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
          p
        }}</a>
      </li>

      <li class="page-item" :class="{ disabled: page == tot_pages }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="get(page + 1)"
          aria-label="Next"
        >
          <i class="mdi mdi-chevron-right"></i>
        </a>
      </li>
    </ul>
    <!--end-->
  </Layout>
</template>

<style scoped>
.purchase-container {
  background: #fafafa;
  margin: 1rem;
  border-radius: 0.5rem;
  padding: 1rem;
}
</style>
